var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{attrs:{"width":"100%","height":"500","scrolling":"no","frameborder":"no","allow":"autoplay","src":_vm.embedSrc}}),_c('p',[_c('router-link',{attrs:{"to":{ name: 'search'}}},[_vm._v("戻る")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }